import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { Place } from '@mui/icons-material';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	List,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import { OBJECTS_TYPES } from '../../../constants';
import { ComplexType } from '../../../types';

export const ComplexCard = ({ data }: { data: ComplexType }) => {
	const translate = useTranslate();
	const { name, id, address, location_data } = data;

	return (
		<Card sx={{ maxWidth: 210, display: 'flex', flexDirection: 'column' }}>
			<CardMedia
				component="img"
				height="140"
				image="https://media.istockphoto.com/id/527211916/photo/lifestyle-apartments-at-dusk.jpg?s=612x612&w=0&k=20&c=WLgEu7VOY5rQs9Y6L-flle6f5b5c6gq8TZDF60gvcp8="
				alt="complex_image"
			/>
			<CardContent
				sx={{
					padding: 1
				}}
			>
				<Typography noWrap variant="h6" component="div">
					{name}
				</Typography>
				<List>
					<ListItem
						component="a"
						target="_blank"
						href={location_data.locationUrl}
						disablePadding={true}
					>
						<Place />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={address}
						/>
					</ListItem>
				</List>
			</CardContent>
			<CardActions
				sx={{
					marginTop: 'auto'
				}}
			>
				<Button
					component={Link}
					to={`/objects/${OBJECTS_TYPES.COMPLEXES}/show/${id}`}
					size="small"
				>
					{translate('list.details')}
				</Button>
			</CardActions>
		</Card>
	);
};
